import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from '../../config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

export const ADDING_PLAYER = () => ({ type: 'ADDING_PLAYER', });
export const ADDING_PLAYER_SUCCESS = () => ({ type: 'ADDING_PLAYER_SUCCESS', });
export const ADDING_PLAYER_ERROR = () => ({ type: 'ADDING_PLAYER_ERROR', });

export const UPDATING_PLAYER = () => ({ type: 'UPDATING_PLAYER', });
export const UPDATING_PLAYER_SUCCESS = () => ({ type: 'UPDATING_PLAYER_SUCCESS', });
export const UPDATING_PLAYER_ERROR = () => ({ type: 'UPDATING_PLAYER_ERROR', });

export const LOADING_PLAYERS = () => ({ type: 'LOADING_PLAYERS', });
export const LOADING_PLAYERS_SUCCESS = () => ({ type: 'LOADING_PLAYERS_SUCCESS', });
export const LOADING_PLAYERS_ERROR = () => ({ type: 'LOADING_PLAYERS_ERROR', });

export const DELETING_PLAYER = () => ({ type: 'DELETING_PLAYER', });
export const DELETING_PLAYER_SUCCESS = () => ({ type: 'DELETING_PLAYER_SUCCESS', });
export const DELETING_PLAYER_ERROR = () => ({ type: 'DELETING_PLAYER_ERROR', });

//export const UPDATING_PLAYER_CHECKS = () => ({ type: 'UPDATING_PLAYER_CHECKS', });


export const getPlayers = (dispatch) => {
  dispatch({ type: LOADING_PLAYERS });

  axios
    .get(`${serverURI}/api/advertise/player/all`)
    .then((res) => {
      dispatch({
        type: LOADING_PLAYERS_SUCCESS,
        payload: res.data.players
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_PLAYERS_ERROR, payload: err });
      errorHandler(err);
    });
};


export const addPlayer = (player, dispatch) => {
  dispatch({ type: ADDING_PLAYER });

  const playerData = new FormData();
  playerData.append('name', player.name);
  playerData.append('file', player.file);
  playerData.append('file_size', player.file_size);
  playerData.append('meter_type', player.meter_type);
  playerData.append('version_code', player.version_code);
  playerData.append('modified_user', player.modified_user);
  playerData.append('modified_at', player.modified_at);
  playerData.append('description', player.description);

  axios
    .post(`${serverURI}/api/advertise/player/add`, playerData)
    .then((res) => {
      dispatch({ type: ADDING_PLAYER_SUCCESS, 
        payload: res.data.player, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_PLAYER_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updatePlayer = (id, player, dispatch) => {
  dispatch({ type: UPDATING_PLAYER });

  const playerData = new FormData();
  playerData.append('name', player.name);
  playerData.append('file', player.file);
  playerData.append('file_size', player.file_size);
  playerData.append('prev_file', player.prev_file);
  playerData.append('meter_type', player.meter_type);
  playerData.append('version_code', player.version_code);
  playerData.append('modified_user', player.modified_user);
  playerData.append('modified_at', player.modified_at);
  playerData.append('description', player.description);

  axios
    .put(`${serverURI}/api/advertise/player/update/${id}`, playerData)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_PLAYER_SUCCESS, 
        payload: res.data.updated_player, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_PLAYER_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deletePlayer = (id, dispatch) => {
  dispatch({ type: DELETING_PLAYER });

  return axios
    .delete(`${serverURI}/api/advertise/player/delete/${id}`)
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_PLAYER_SUCCESS, 
        payload: res.data.removedPlayer, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_PLAYER_ERROR, payload: err });
      errorHandler(err);
    });
};
